<template>
  <section id="background" class="background">
    <div class="container">
      <i />
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'sso_background'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}sso/';

.background {
  .position();
  z-index: 0;
  width: 100%;
  height: 100%;
  
  .container {
    overflow: hidden;
    position: relative;
    max-width: @grid_xl;
    height: 100%;
    margin: 0 auto;
    
    > i {
      display: block;
      .position(absolute, 50%, -5%, auto, auto);
      .transform(translate(0, -50%));
      .bg('@{image}background.png', 744px, 622px, true);
      pointer-events: none;
    }
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .background {
    .container {
      > i {
        right: -15%;
      }
    }
  }
}

@media screen and (max-width: -1px+@grid_sm) {
  .background {
    .container {
      > i {
        right: -53%;
      }
    }
  }
}
</style>